import * as DOMElements from './DOMElements';

const isDebug = window.location.hash === "#debug" || window.location.hash === "debug";

const isAtTheBottom = (element, tolerance = 20) =>
    element.scrollTop + element.clientHeight >= element.scrollHeight - tolerance

export const getMessageList = () => document.getElementById('chat')

export const createMessage = (id, text, authorType, avatar) => {
    const messageDivContainer = document.createElement('div')
    messageDivContainer.dataset.id = id
    messageDivContainer.classList.add('message-container', authorType)
    if (avatar) {
        const avatarImage = document.createElement('img')
        avatarImage.src = avatar
        avatarImage.classList.add('agent-avatar')
        messageDivContainer.append(avatarImage)
    }
    const messageDiv = document.createElement('div')
    messageDiv.classList.add('message')
    messageDiv.innerHTML = '<div>' + text + '</div>'
    messageDivContainer.append(messageDiv)
    return messageDivContainer
}

export const appendMessage = message => {
    const messageList = getMessageList()
    const shouldScrollToBottom = isAtTheBottom(messageList)
    messageList.appendChild(message)

    if (shouldScrollToBottom) {
        scrollToBottom()
    }
}

export const fitScrolled = () => {
    const messageList = getMessageList()
    const shouldScrollToBottom = isAtTheBottom(messageList)

    if (shouldScrollToBottom) {
        scrollToBottom()
    }
}

export const prependMessages = (chatId, messages) => {
    const messageList = getMessageList(chatId)
    messages.reverse().forEach(message => {
        const firstMessage = messageList.children[0]
        if (firstMessage) {
            messageList.insertBefore(message, firstMessage)
            return
        }
        appendMessage(chatId, message)
    })
}

export const markAsFailedMessage = id => {
}

export const confirmMessageAsSent = id => {
}

export const disableInput = text => {
    if (text) {
        DOMElements.input.placeholder = text
    }
    DOMElements.input.disabled = true
}

export const enableInput = () => {
    DOMElements.input.placeholder = 'Wpisz wiadomość'
    DOMElements.input.disabled = false
}

export const disableSendButton = () => {
    DOMElements.sendButton.disabled = true
}

export const enableSendButton = () => {
    DOMElements.sendButton.disabled = false
}

export const toggleMinimized = () => {
    DOMElements.lcWindow.classList.toggle('minimized')
    DOMElements.lcWindowMinimized.classList.toggle('minimized')
}

export const scrollToBottom = () => {
    const messageList = getMessageList()

    messageList.scrollTop = messageList.scrollHeight
}

export const scrollElementToBottom = (element) => {
    //debugMessage("scrollTop: " + element.scrollTop);
    //debugMessage("scrollHeight: " + element.scrollHeight);

    element.scrollTop = element.scrollHeight
}

export const showChat = () => {
    DOMElements.startChatButton.style.display = 'none'
    DOMElements.textareaWrapper.style.display = 'flex'

    DOMElements.input.focus()
}

export const hideChat = () => {
    DOMElements.textareaWrapper.style.display = 'none'
}

export const showFooter = () => {
    DOMElements.footer.style.display = 'block'
}

export const hideFooter = () => {
    DOMElements.footer.style.display = 'none'
}

export const isFooterShown = () => {
    return DOMElements.footer.style.display == 'block'
}

export const showPresurvey = () => {
    DOMElements.presurvey.style.display = 'block'
}

export const hidePresurvey = () => {
    DOMElements.presurvey.style.display = 'none'
}

export const showStartChatButton = () => {
    DOMElements.startChatButton.style.display = 'inline-block'
}

export const showOfflineAgentsInfo = () => {
    DOMElements.agentsOfflineInfo.style.display = 'block';
    DOMElements.agentsOfflinePresurveyInfo.style.display = 'block';
}

export const hideOfflineAgentsInfo = () => {
    DOMElements.agentsOfflineInfo.style.display = 'none';
    DOMElements.agentsOfflinePresurveyInfo.style.display = 'none';
}

export const isAfterWorkHours = (date) => {
    return date.getDay() == 0 || date.getDay() == 6 || date.getHours() >= 16 || (date.getHours() > 16 && date.getHours() < 8 && date.getMinutes() < 30)
}

export const showOfflineSection = () => {
    const date = new Date();

    if (isAfterWorkHours(date)) {
        DOMElements.offlineSectionOffline.style.display = 'block';
        DOMElements.offlineSectionOccupied.style.display = 'none';
    } else {
        DOMElements.offlineSectionOffline.style.display = 'none';
        DOMElements.offlineSectionOccupied.style.display = 'block';
    }

    DOMElements.offlineSection.style.display = 'block';
}

export const hideOfflineSection = () => {
    DOMElements.offlineSection.style.display = 'none';
}


const closest = (to, element) => {
    const toClass = to.substr(1)
    let target = element
    while (target) {
        if (target.classList.contains(toClass)) {
            return target
        }
        target = target.parentElement
    }

    return null
}

export const delegate = (from, to, eventName, handler) => {
    const targetSelector = `${to}, ${to} *`

    document.querySelector(from).addEventListener(eventName, ev => {
        if (!ev.target.matches(targetSelector)) {
            return
        }

        handler.call(closest(to, ev.target), ev)
    })
}

// TODO: dedupe it later its a copy from "@livechat/chat.io/utils"
// with exception that this one handles context passing
export const throttle = (ms, fn) => {
    let lastCall = Date.now() - 2 * ms
    let result
    let trailing

    function invoke(...args) {
        lastCall = Date.now()
        return (result = fn.apply(this, args))
    }

    return function throttler(...args) {
        const now = Date.now()

        if (now - lastCall >= ms) {
            return invoke.apply(this, args)
        }

        clearTimeout(trailing)
        trailing = setTimeout(() => invoke.apply(this, args), lastCall - now + ms)

        return result
    }
}

const element_from_string = (code) => {
    const domParser = new DOMParser();
    const doc = domParser.parseFromString(code, 'text/html');
    return doc.body.children[0];
}

const create_field = (field) => {
    if (isDebug) console.log(field);
    let element = undefined;
    switch (field.type) {
        case 'header':
            let text = field.label.replaceAll('<br>', '');
            element = element_from_string(`<div class="chat-note mb-4"><div class="chat-note__wrapper"><div class="chat-note__inner">${field.label.replaceAll('<br>', '')}</div></div></div>`);
            return element;
        case 'name':
            element = element_from_string(`<div class="simple-form__field-container"><label class="form-field ${field.required ? 'form-field--required' : ''}" for="ticket-form-input-${field.id}"><div class="form-field__wrapper"><header class="form-field__header"><h4 class="form-field__title">${field.label}</h4></header><div class="form-field__content"><input id="ticket-form-input-${field.id}" data-field-id="${field.id}" type="${field.type === 'email' ? 'email' : 'text'}" data-field-type="${field.type}" class="form-field__core" ${field.required ? 'required' : ''} autocomplete="given-name"/></div></div></label></div>`);
            return element;
        case 'email':
            element = element_from_string(`<div class="simple-form__field-container"><label class="form-field ${field.required ? 'form-field--required' : ''}" for="ticket-form-input-${field.id}"><div class="form-field__wrapper"><header class="form-field__header"><h4 class="form-field__title">${field.label}</h4></header><div class="form-field__content"><input id="ticket-form-input-${field.id}" data-field-id="${field.id}" type="${field.type === 'email' ? 'email' : 'text'}" data-field-type="${field.type}" class="form-field__core" ${field.required ? 'required' : ''} autocomplete="email"/></div></div></label></div>`);
            return element;
        case 'subject':
        case 'question':
            element = element_from_string(`<div class="simple-form__field-container"><label class="form-field ${field.required ? 'form-field--required' : ''}" for="ticket-form-input-${field.id}"><div class="form-field__wrapper"><header class="form-field__header"><h4 class="form-field__title">${field.label}</h4></header><div class="form-field__content"><input id="ticket-form-input-${field.id}" data-field-id="${field.id}" type="${field.type === 'email' ? 'email' : 'text'}" data-field-type="${field.type}" class="form-field__core" ${field.required ? 'required' : ''}/></div></div></label></div>`);
            if (field.label === 'Telefon:') {
                element = element_from_string(`<div class="simple-form__field-container"><label class="form-field ${field.required ? 'form-field--required' : ''}" for="ticket-form-input-${field.id}"><div class="form-field__wrapper"><header class="form-field__header"><h4 class="form-field__title">${field.label}</h4></header><div class="form-field__content"><input id="ticket-form-input-${field.id}" data-field-id="${field.id}" type="${field.type === 'email' ? 'email' : 'text'}" data-field-type="${field.type}" class="form-field__core" ${field.required ? 'required' : ''} autocomplete="tel"/></div></div></label></div>`);
            }
            return element;
        case 'textarea':
            element = element_from_string(`<div class="simple-form__field-container"><label class="form-field ${field.required ? 'form-field--required' : ''}" for="ticket-form-textarea-${field.id}"><div class="form-field__wrapper"><header class="form-field__header"><h4 class="form-field__title">${field.label}</h4></header><div class="form-field__content"><textarea id="ticket-form-textarea-${field.id}" data-field-id="${field.id}" data-field-type="${field.type}" class="form-field__core" ${field.required ? 'required' : ''}></textarea></div></div></label></div>`);
            return element;
        case 'radio':
        case 'select':
        case 'checkbox':
        default:
            if (isDebug) console.log(`Pole ${field.type} jest nieobsługiwane`, field);
            return false;
    }
};

export const formDataToForm = (fields, onsubmit) => {
    const insert_before = DOMElements.offlineForm.querySelector('.insert-before')
    const fieldset = insert_before.parentNode;

    fields.forEach((field) => {
        const element = create_field(field);
        if (element) {
            fieldset.insertBefore(element, insert_before)
        }
    });
    fieldset.removeChild(insert_before);

    DOMElements.offlineForm.onsubmit = onsubmit;
};

export const formToData = (form) => {
    const fields = [];
    const inputs = form.querySelectorAll('[data-field-id]');
    [...inputs].forEach(input => {
        let description = '';
        let label = input.labels[0];
        if (label) {
            label = label.querySelector('.single-checkbox__description') || label.querySelector('.form-field__title');
            if (label) {
                description = label.innerText.trim();
            }
        }
        fields.push({
            id: input.dataset.fieldId.toString(),
            type: input.dataset.fieldType.toString(),
            label: description,
            answer: input.value,
        });
    });
    return fields;
};
